import { schema } from 'normalizr'
import { request_reasonInput } from 'schema/request_reasonInput'

export const categoryInput = new schema.Entity('categories', {
  request_reasons: [request_reasonInput]
}, {
  idAttribute: 'uuid'
})